export const RTC_CONTROLLER_INIT_TIMEOUT = 15000;
export const RTC_CONTROLLER_POLLING_INTERVAL = 30000;
export const RTC_DEFAULT_ACTION_DELAY_SECONDS = 30;
export const RTC_LIVE_USERS_DEBOUNCE_TIME = 1000;
export const RTC_OUT_OF_ORDER_EVENT_TIMEOUT = 5000;
export const RTC_OFFLINE_DETECTION_TIMEOUT = 5000;
